import {
    createWebHashHistory,
    createRouter
} from 'vue-router'


import dungeonquestidle from '@/views/dungeonidleprivacypolicy.vue'
import cublerprivacypolicy from '@/views/cublerprivacypolicy.vue'
import lightholmprivacypolicy from '@/views/lightholmprivacypolicy.vue'
import deadgateprivacypolicy from '@/views/deadgateprivacypolicy.vue'
import NotFound from '@/views/notfound.vue'

const routes = [
    {
        path: '/dungeonquestidle/privacypolicy',
        component: dungeonquestidle
    },
    {
        path: '/cubler/privacypolicy',
        component: cublerprivacypolicy
    },
    {
        path: '/lightholm/privacypolicy',
        component: lightholmprivacypolicy
    },
    {
        path: '/deadgate/privacypolicy',
        component: deadgateprivacypolicy
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound
      }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
})

export default router